import { render, staticRenderFns } from "./retailerProductTab.vue?vue&type=template&id=c1d17fa0&scoped=true"
import script from "./retailerProductTab.vue?vue&type=script&lang=js"
export * from "./retailerProductTab.vue?vue&type=script&lang=js"
import style0 from "./retailerProductTab.vue?vue&type=style&index=0&id=c1d17fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d17fa0",
  null
  
)

export default component.exports